<template>
  <el-popover
    placement="bottom"
    width="400"
    trigger="click"
    popper-class="accountWrap"
  >
    <template slot="reference">
      <el-avatar
        :size="40"
        class="avatarButton"
        :src="user && user.user && user.user.profile_image ? user.user.profile_image : null"
      >
        <div class="emptyAvatar small">
          {{ initials }}
        </div>
      </el-avatar>
    </template>

    <div>
      <div class="topContainer">
        <div class="left">
          <el-avatar
            v-if="user.user.profile_image"
            :size="75"
            :src="user.user.profile_image"
          />
          <el-avatar
            v-else-if="!initials"
            :size="75"
            icon="el-icon-user-solid"
            class="avatarButton"
          />
          <div
            v-else
            class="emptyAvatar big"
          >
            {{ initials }}
          </div>
        </div>

        <div class="right">
          <div class="name">
            {{ user.user.first_name }} {{ user.user.last_name }}
          </div>

          <div class="email">
            {{ user.user.email }}
          </div>

          <el-button
            v-if="user.user.is_cas_user"
            round
            @click="clickManage"
          >
            {{ $t('common.manageAccount') }}
          </el-button>
        </div>
      </div>

      <el-divider />

      <div class="bottomContainer">
        <el-button
          type="text"
          @click="logoutUser"
        >
          {{ $t('common.logout') }}
        </el-button>
      </div>
    </div>
  </el-popover>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'AccountMenu',

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    initials() {
      if ((!this.user || !this.user.user)
        || (!this.user.user.full_name && !this.user.user.first_name && !this.user.user.last_name)) return 'X_X';

      let init1 = '';
      let init2 = '';
      if (this.user.user.full_name) {
        const list = this.user.user.full_name.split(' ');
        init1 = String(list[0].substring(0, 1).toUpperCase());
        init2 = String(list[1].substring(0, 1).toUpperCase());
      } else {
        if (this.user.user.first_name) {
          init1 = this.user.user.first_name[0].substring(0, 1).toUpperCase();
        }
        if (this.user.user.last_name) {
          init2 = this.user.user.last_name[0].substring(0, 1).toUpperCase();
        }
      }
      return `${init1} ${init2}`;
    },
  },

  methods: {
    ...mapActions('user', [
      'logout',
    ]),

    async logoutUser() {
      this.$Progress.start();
      await this.logout();
      if (process.env.VUE_APP_COMPONENT_LOGIN) {
        this.$router.push({ name: 'login' }).catch((err) => {});
      } else {
        window.location.href = process.env.VUE_APP_CAS_CLIENT;
      }
    },

    clickManage() {
      window.open(`${process.env.VUE_APP_CAS_CLIENT}/settings`, '_self');
      // this.$router.push({ name: 'setting' });
    },
  },
};
</script>

<style lang="scss" scoped>
.avatarButton {
  cursor: pointer;
}

.emptyAvatar {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2196f3;
  color: white;
  border-radius: 100%;

  &.small {
    width: 40px;
    height: 40px;
    font-size: 14px;
    outline: none;
  }

  &.big {
    width: 75px;
    height: 75px;
    font-size: 25px;
  }
}

.el-divider {
  margin-top: 10px;
  margin-bottom: 10px;
}

.topContainer {
  display: flex;
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;

  .left {
    margin-right: 25px;

    .avatarIcon {
      font-size: 30px;
    }
  }

  .right {
    .name {
      font-size: 1.5rem;
      margin-bottom: 5px;
    }

    .email {
      margin-bottom: 10px;
      line-height: 1.2;
      font-size: 0.875rem;
      font-style: italic;
    }
  }
}

.bottomContainer {
  display: flex;
  justify-content: flex-end;

  .el-button {
    margin-right: 15px;
  }
}
</style>

<style lang="scss">
  .accountWrap {
    max-width: calc(100vw - 35px);
    overflow: auto;
  }
</style>
